<template>
  <header class="thing-single-header thing-header_inner things-header"
          @mouseleave="showMenu = false">
    <h1 class="title thing-title hint-cont">
      <button type="button" @click="goBack()">
        <chevron-left :fill="'#109CF1'"></chevron-left>
      </button>
      <trim-item :string="thing.name"
                 :width="1"></trim-item>
<!--      {{trimName(things.name)}}-->
      <span class="btn-hint name-hint btn-hint_bottom" v-if="nameTooltip">
        {{things.name}}
      </span>
    </h1>


    <div v-if="isHeaderSettingsEditActive" class="header-right">
<!--      <pre>{{onEditingInputs}}</pre>-->
      <ul class="controls-list header-controls">
        <li class="control-item">
          <!--            @click="cancel"-->
          <button type="button"
                  class="btn btn-transparent_blue"
                  @click="setEditableOffAndClear">
            {{$t('btns.cancel')}}
          </button>
        </li>
        <li class="control-item">
          <button type="submit"
                  class="btn btn-blue"
                  :class="{'loading': loading}"
                  @click="updateThingNow">
            {{$t('btns.save')}}
          </button>
        </li>
      </ul>
    </div>

    <div v-if="!isHeaderSettingsEditActive" class="header-right">
      <router-link :to="`/journals/journal-${this.routeId}`"
                   class="btn btn-journal btn-transparent_blue">
        {{$t('index.journal.title')}}
<!--        <span class="new-counter ">2</span>-->
      </router-link>
      <ul class="controls-list">
        <li class="control-item">
          <button type="button"
                  @click="copyAddressBar"
                  class="control-btn-new hover-blue-new hint-cont">
            <copy-link-icon></copy-link-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom"
               :class="{'hide-for-copy': isCopyingNow}">
              {{$t('things.headerSingle.copy')}}
            </p>
            <p class="btn-hint btn-hint_light btn-hint_bottom"
               :class="{'hide-for-copy': !isCopyingNow}">
              {{$t('things.headerSingle.wasCopied')}}
            </p>
          </button>
        </li>
        <li class="control-item" v-if="thingInProject() && thing.permission_level === 4">
          <button type="button"
                  @click="showSharePopup('device')"
                  class="control-btn-new hover-blue-new hint-cont">
            <share-icon></share-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom share-hint">
              {{$t('things.headerSingle.share')}}
            </p>
          </button>
        </li>
        <li class="control-item" v-if="thing.permission_level > 2 && isOwnerForThing">
          <button type="button"
                  @click="showConfirmPopup"
                  class="control-btn-new hover-blue-new hint-cont">
            <del-icon></del-icon>
            <p v-if="!thing.virtual" class="btn-hint btn-hint_light btn-hint_bottom ">
              {{$t('things.headerSingle.del')}}
            </p>
            <p v-else class="btn-hint btn-hint_light btn-hint_bottom note-to-center">
              {{$t('things.headerSingle.destroy')}}
          </p>
          </button>
        </li>
        <li class="control-item" v-if="thing.permission_level === 4">
          <button type="button"
                  @click="showMenu = !showMenu"
                  class="control-btn-new hover-blue-new hover-blue_fill">
            <dots-icon></dots-icon>
          </button>
          <thing-other-menu v-show="showMenu"
                            @mouseleave="showMenu = false"
                            class="other-menu"></thing-other-menu>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
  import {thingSingleHeader} from "../../../../../mixins/things/thingSingleHeader";
  import {filters} from "../../../../../mixins/filters";
  import trimItem from '../../../../../components/trimITem'
  import chevronLeft from '../../../../Svg/chevronLeft'

  import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'


  export default {
    name: 'thingSingleHeader',
    mixins: [thingSingleHeader, filters],
    data() {
      return {
        loading: false,
        isCopyingNow: false
      }
    },
    components: {
      trimItem,
      chevronLeft
    },
    computed: {
      ...mapState({
        isHeaderSettingsEditActive: state => state.things.isHeaderSettingsEditActive,
        onEditingInputs: state => state.things.onEditingInputs,
        thing: state => state.things.device,
        newAvatar: state => state.things.newAvatar,
        projects: state => state.projects.allProjects,
        user: state => state.auth.user
      }),
      ...mapGetters({
        thingsFirstData: 'things/firstLevelThings',
      }),
      isOwnerForThing() {
        if (this.thing.owner_role_id === this.user.active_role_id) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      ...mapMutations({
        setSettingsNodeEditable: 'things/SET_SETTINGS_NODE_EDITABLE',
        setHeaderSettingsEditActive: 'things/SET_HEADER_SETTINGS_EDIT_ACTIVE'
      }),
      ...mapActions({
        updateDevice: 'things/updateDevice',
        getDeviceAction: 'things/getDevice',
        getDevices: 'things/getDevices',
        setNewAvatar: 'things/setNewAvatar',
        deleteDeviceIMG: 'things/deleteDeviceIMG',
        createDeviceTag: 'things/createDeviceTag',
        unsetDeviceTag: 'things/unsetDeviceTag',
        removeFile: 'global/removeFile',
      }),
      goBack() {
        window.history.back();
      },
      thingInProject() {
        let flag = false
        let deviceFunc = (data) => {
          data.devices.forEach((device) => {
            if (device.id === this.thing.id) {
              flag = true
            }
          })
        }
        let projectFunc = (data) => {
          data.forEach((item) => {
            if (item.devices.length > 0) {
              item.devices.forEach((device) => {
                if (device.id === this.thing.id) {
                  flag = true
                }
                if (device.devices.length > 0) {
                  deviceFunc(device)
                }
              })
            }
          })
        }
        this.projects.forEach((project) => {
          if (project.items.length > 0) {
            projectFunc(project.items)
          }
        })
        return flag;
      },
      setEditableNodeSettings(val) {
        this.setSettingsNodeEditable(val);
        this.setHeaderSettingsEditActive(val)
      },
      setEditableOffAndClear() {
        this.setEditableNodeSettings(false)
        this.setNewAvatar(false)
      },
      async updateThingNow() {
        let added_tags = '';

        for(let x = 0; x < this.onEditingInputs.tags.length; x++) {
          let is_added = true;

          for(let i = 0; i < this.thing.tags.length; i++) {
            if(this.thing.tags[i].id == this.onEditingInputs.tags[x].id) {
              is_added = false;

              break;
            }
          }

          if(is_added) {
            if(added_tags != '') {
              added_tags += ',';
            }

            added_tags += this.onEditingInputs.tags[x].name;
          }
        }

        if(added_tags) {
          await this.createDeviceTag({tags: added_tags, object_type: 'device', object_id: this.$route.params.id}).then(res => {
          });
        }

        let unseted_tags = '';

        for(let x = 0; x < this.thing.tags.length; x++) {
          let is_delete = true;

          for(let i = 0; i < this.onEditingInputs.tags.length; i++) {
            if(this.thing.tags[x].id == this.onEditingInputs.tags[i].id) {
              is_delete = false;

              break;
            }
          }

          if(is_delete) {
            if(unseted_tags != '') {
              unseted_tags += ',';
            }

            unseted_tags += this.thing.tags[x].name;
          }
        }

        if(unseted_tags) {
          await this.unsetDeviceTag({tags: unseted_tags, object_type: 'device', object_id: this.$route.params.id}).then(res => {
          });
        }

        this.loading = true;

        let data = {
          device_id: this.$route.params.id,
          name: this.onEditingInputs.name,
          description: this.onEditingInputs.description.replace('style="cursor: nesw-resize;"', ''),
          image: this.newAvatar,
          system_name: this.onEditingInputs.system_name
        }

        let formData = new FormData()

        for (let key in data) {
          formData.append(key, data[key])
        }

        if (this.onEditingInputs.ids.length > 0) {
          let removeFileData = {
            ids: this.onEditingInputs.ids
          }
          await this.removeFile(removeFileData);
        }

        if(this.newAvatar === 'del') {
          await this.deleteDeviceIMG(this.$route.params.id)
        }
        await this.updateDevice(formData)
        await this.getDeviceAction(this.$route.params.id)

        this.thing.name = data.name

        data = {}

        this.setEditableOffAndClear()
        this.loading = false
      },
      async copyAddressBar() {
        const routerPath = this.$route.path
        const fullUrl = window.location.origin + routerPath
        await navigator.clipboard.writeText(fullUrl)
          .then(() => {
            //ссылка скопирована в буфер обмена
            this.isCopyingNow = true
            setTimeout(() => this.isCopyingNow = false, 1200)
          })
      }
    },
    mounted() {}
  }
</script>

<style lang="scss" scoped>
ul li button {
  display: flex;
  align-items: center;
  justify-content: center;
}
.thing-title {
  margin-left: 0;
}
.title {
  width: calc(100% - 410px) !important;
  line-height: 16px !important;
}
.btn {
  width: 200px;
}
.hide-for-copy {
  display: none !important;
}
.note-to-center {
  left: calc(50% - 67px);
}
</style>
